import api from '@/services/api';

const CompanyContractTagUpdate = {
  updateCompanyContractTag: (companyContractTagId, companyContractTagName) => {
    return api.post('update_company_contract_tag/', {
      companyContractTagId: companyContractTagId,
      companyContractTagName: companyContractTagName
    });
  },
  updateCompanyContractTagV2: (companyContractTagId, companyContractTagName, remarks, color) => {
    return api.post('update_company_contract_tag_v2/', {
      companyContractTagId: companyContractTagId,
      companyContractTagName: companyContractTagName,
      remarks: remarks,
      color: color
    });
  },
  deleteCompanyContractTag: companyContractTagId => {
    return api.post('delete_company_contract_tag/', {
      companyContractTagId: companyContractTagId
    });
  }
};

export default CompanyContractTagUpdate;



// WEBPACK FOOTER //
// ./src/api/tag/update.js